import React, { useState, useCallback } from 'react';
import './AppToast.css';

// ─── Single toast ─────────────────────────────────────────────────────────────

const Toast = ({ toast, onDismiss, iconPreset }) => {
  const [leaving, setLeaving] = useState(false);

  const triggerLeave = useCallback(() => {
    if (leaving) return;
    setLeaving(true);
    // Wait for leave animation to finish before removing from DOM
    setTimeout(() => onDismiss(toast.id), 420);
  }, [leaving, toast.id, onDismiss]);

  // Progress bar end → begin leave animation
  const handleProgressEnd = useCallback(() => {
    triggerLeave();
  }, [triggerLeave]);

  const showProgress = toast.duration !== -1;
  const icon = iconPreset[toast.type] ?? 'ℹ️';

  return (
    <div
      className={`at-toast at-toast--${toast.type}${leaving ? ' at-toast--out' : ''}`}
      role="alert"
      aria-live="polite"
    >
      <div className="at-toast__top">
        <span className="at-toast__icon" aria-hidden="true">{icon}</span>

        <div className="at-toast__body">
          {toast.title && <p className="at-toast__title">{toast.title}</p>}
          <p className="at-toast__message">{toast.message}</p>
        </div>

        <button
          className="at-toast__close"
          onClick={triggerLeave}
          aria-label="Fermer"
        >
          ✕
        </button>
      </div>

      {showProgress && (
        <div
          className={`at-toast__bar at-toast__bar--${toast.type}`}
          style={{ animationDuration: `${toast.duration}ms` }}
          onAnimationEnd={handleProgressEnd}
        />
      )}
    </div>
  );
};

// ─── Stack ────────────────────────────────────────────────────────────────────

const AppToast = ({ toasts, onDismiss, iconPreset }) => {
  if (!toasts.length) return null;

  return (
    <div className="at-stack" aria-label="Notifications">
      {toasts.map(t => (
        <Toast key={t.id} toast={t} onDismiss={onDismiss} iconPreset={iconPreset} />
      ))}
    </div>
  );
};

export default AppToast;
